import ListItemLoading from "@/components/loading/listItemLoading/listItemLoading";
import useIsSmall from "@/hooks/useIsSmall";
import { UserWorkScheduleAppointmentDto } from "@/models/club";
import AddShift from "@/modules/team/addShift";
import AddShiftMenu from "@/modules/team/addShift/AddShiftMenu";
import AddTimeSlotForOneDay from "@/modules/team/addShift/AddTimeSlotForOneDay";
import ScheduleItem from "@/modules/team/list/scheduleItem";
import { useShiftSchedule } from "@/services/shiftSchedule/utils";
import {
  Accordion,
  Button,
  Container,
  Divider,
  Drawer,
  Grid,
  GridCol,
  Group,
  Skeleton,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCalendarOff, IconCirclePlus } from "@tabler/icons-react";
import moment, { Moment } from "moment-jalaali";
import { useState } from "react";
import ShiftsScheduleHeader from "./ShiftsScheduleHeader";
import { getCurrentWeek } from "./type";
import NotWorkingButton from "@/modules/team/list/notWorkingButton";
import "./style.css";

function ShiftsSchedule() {
  const [selectedDate, setSelectedDate] = useState<Date[]>(getCurrentWeek());
  const [selectedEditDate, setSelectedEditDate] = useState<Moment | null>(null);
  const {
    data: shiftSchedule,
    isLoading: isShiftScheduleLoading,
    refetch: refetchShiftSchedule,
  } = useShiftSchedule({
    fromDate: moment(selectedDate?.[0]).format("YYYY-MM-DD"),
    toDate: moment(selectedDate?.[1]).format("YYYY-MM-DD"),
  });
  const isSmall = useIsSmall(1200);
  const [selectedTeam, setSelectedTeam] =
    useState<UserWorkScheduleAppointmentDto | null>(null);

  const [opened, { open, close }] = useDisclosure(false);
  const [openedMenu, { open: openMenu, close: closeMenu }] =
    useDisclosure(false);
  const [
    openedOneDayShift,
    { open: openOneDayShift, close: closeOneDayShift },
  ] = useDisclosure(false);

  const days: moment.Moment[] = [];
  const start = moment(selectedDate[0]);
  const end = moment(selectedDate[1]);
  const totalDays = Math.min(end.diff(start, "days") + 1, 7);

  for (let i = 0; i < totalDays; i++) {
    const currentDay = start.clone().add(i, "days");
    days.push(currentDay);
  }
  return (
    <>
      <ShiftsScheduleHeader
        title="شیفت کاری"
        selectedDate={selectedDate || []}
        setSelectedDate={setSelectedDate}
      />
      <Container w="100%" size="full" bg="white" mt="md">
        {isSmall && <Title order={4}> شیفت کاری </Title>}

        <Stack mt="md" justify="start" flex={1}>
          {!isSmall ? (
            <>
              <Grid
                styles={{
                  col: {
                    border: "1px solid var(--mantine-color-gray-3)",
                    borderRadius: "var(--mantine-radius-md)",
                  },
                }}
              >
                <GridCol
                  span="auto"
                  styles={{
                    col: {
                      border: "none",
                    },
                  }}
                  px="0"
                ></GridCol>
                {days?.map((currentDay) => {
                  const persianDate = currentDay.format("jD jMMMM");
                  return (
                    <GridCol span="auto" px="0">
                      <Stack justify="center" align="center">
                        <Text fw="bold">{persianDate}</Text>
                      </Stack>
                    </GridCol>
                  );
                })}
              </Grid>
              {isShiftScheduleLoading ? (
                <Grid
                  styles={{
                    col: {
                      border: "1px solid var(--mantine-color-gray-3)",
                      borderRadius: "var(--mantine-radius-md)",
                    },
                  }}
                >
                  <GridCol span="auto" px="0">
                    <Stack justify="center" mih="70px" align="center">
                      <Group justify="space-between">
                        <Group justify="space-between">
                          <Group justify="center">
                            <Skeleton w={35} h={35} radius={100} />
                            <Stack gap="0" justify="center" align="center">
                              <Skeleton w={100} h={20} />
                            </Stack>
                          </Group>
                        </Group>
                      </Group>
                    </Stack>
                  </GridCol>
                  {days?.map(() => {
                    return (
                      <GridCol span="auto" px="0">
                        <Stack justify="center" align="center" mih="70px">
                          <Skeleton radius="xl" w={75} h={25} />
                        </Stack>
                      </GridCol>
                    );
                  })}
                </Grid>
              ) : (
                shiftSchedule?.map((team) => (
                  <Grid
                    styles={{
                      col: {
                        border: "1px solid var(--mantine-color-gray-3)",
                        borderRadius: "var(--mantine-radius-md)",
                      },
                    }}
                  >
                    <GridCol span="auto" px="2">
                      <Stack justify="center" mih="70px" align="center">
                        <ScheduleItem size="sm" team={team?.user || {}} />
                      </Stack>
                    </GridCol>
                    {days?.map((currentDay) => {
                      const matchingDay = team?.workScheduleCalendar?.find(
                        (day) => {
                          const scheduleDate = moment(day?.availableDate);
                          return scheduleDate.isSame(currentDay, "day");
                        }
                      );

                      return (
                        <GridCol span="auto" px="5">
                          <Stack justify="flex-start" align="center" mih="70px" className="time-column"
                          >
                            <>

                              {/* <Group gap="xs" w="100%" justify="space-between" p={0}> */}
                              {matchingDay?.timeSlots &&
                                matchingDay.timeSlots.length > 0 ? (
                                <Stack gap="5" px="0" w="100%">
                                  {matchingDay.timeSlots.map(
                                    (timeSlot, idx) => {
                                      return (
                                        <>
                                          <Button
                                            variant="light"
                                            px="xs"
                                            fullWidth
                                            className="slot-btn"
                                            key={idx}

                                            onClick={() => {
                                              setSelectedTeam(team);
                                              setSelectedEditDate(currentDay);
                                              openMenu();
                                            }}
                                          >
                                            <Text
                                              key={idx}
                                              size="xs"
                                              c="gray.7"
                                              fw="500"
                                            >
                                              {moment(
                                                timeSlot?.endTime,
                                                "HH:mm:ss"
                                              ).format("HH:mm")}{" "}
                                              -{" "}
                                              {moment(
                                                timeSlot?.startTime,
                                                "HH:mm:ss"
                                              ).format("HH:mm")}
                                            </Text>
                                          </Button>
                                        </>
                                      );
                                    }
                                  )}
                                  <>
                                    <Button fullWidth size="xs" className="add-btn" variant="light" onClick={() => {
                                      setSelectedTeam(team);
                                      setSelectedEditDate(currentDay);
                                      openOneDayShift();
                                    }}>
                                      <IconCirclePlus size={20} stroke={1} />
                                    </Button>
                                  </>
                                </Stack>
                              ) : (
                                <NotWorkingButton onClick={() => {
                                  setSelectedTeam(team);
                                  setSelectedEditDate(currentDay);
                                  openOneDayShift();
                                }} />

                              )}
                              {/* </Group> */}
                              <Divider />
                            </>
                          </Stack>
                        </GridCol>
                      );
                      // Find matching day in workScheduleCalendar
                      // const matchingDay =
                      //   team?.workScheduleCalendar?.find(
                      //     (day) => {
                      //       const scheduleDate = moment(
                      //         day?.availableDate
                      //       );
                      //       return scheduleDate.isSame(
                      //         currentDay,
                      //         "day"
                      //       );
                      //     }
                      //   )}
                    })}
                  </Grid>
                ))
              )}
            </>
          ) : (
            <Stack gap="lg">
              {isShiftScheduleLoading && <ListItemLoading count={4} />}
              <Accordion variant="filled" radius="md">
                {shiftSchedule?.map((team) => (
                  <Accordion.Item
                    key={team?.user?.id}
                    value={team?.user?.id?.toString() || ""}
                  >
                    <Accordion.Control>
                      <ScheduleItem team={team?.user || {}} />
                    </Accordion.Control>
                    <Accordion.Panel>
                      {team?.workScheduleCalendar &&
                        team?.workScheduleCalendar?.length > 0 ? (
                        <>
                          {(() => {
                            // Generate 7 days between selected dates
                            return (
                              <>
                                <Stack gap="md">
                                  {days?.map((currentDay, index) => {
                                    const dayName = currentDay.format("dddd");
                                    const persianDate =
                                      currentDay.format("jD jMMMM");

                                    // Find matching day in workScheduleCalendar
                                    const matchingDay =
                                      team?.workScheduleCalendar?.find(
                                        (day) => {
                                          const scheduleDate = moment(
                                            day?.availableDate
                                          );
                                          return scheduleDate.isSame(
                                            currentDay,
                                            "day"
                                          );
                                        }
                                      );

                                    return (
                                      <>
                                        <Group
                                          key={index}
                                          gap="xs"
                                          justify="space-between"
                                        >
                                          <Text fw="500" size="sm">
                                            {dayName}، {persianDate}
                                          </Text>
                                          {matchingDay?.timeSlots &&
                                            matchingDay.timeSlots.length > 0 ? (
                                            <Stack gap="xs">
                                              {matchingDay.timeSlots.map(
                                                (timeSlot, idx) => {
                                                  // const startTime = `${String(
                                                  //   timeSlot.startTime?.hour ?? 0
                                                  // ).padStart(2, "0")}:${String(
                                                  //   timeSlot.startTime?.minute ?? 0
                                                  // ).padStart(2, "0")}`;
                                                  // const endTime = `${String(
                                                  //   timeSlot.endTime?.hour ?? 0
                                                  // ).padStart(2, "0")}:${String(
                                                  //   timeSlot.endTime?.minute ?? 0
                                                  // ).padStart(2, "0")}`;

                                                  return (
                                                    <Button
                                                      variant="light"
                                                      radius="100px"
                                                      px="xs"
                                                      key={idx}
                                                      onClick={() => {
                                                        setSelectedTeam(team);
                                                        setSelectedEditDate(
                                                          currentDay
                                                        );
                                                        openMenu();
                                                      }}
                                                    >
                                                      <Text
                                                        key={idx}
                                                        size="sm"
                                                        c="gray.7"
                                                        fw="500"
                                                      >
                                                        {moment(
                                                          timeSlot?.endTime,
                                                          "HH:mm:ss"
                                                        ).format("HH:mm")}{" "}
                                                        -{" "}
                                                        {moment(
                                                          timeSlot?.startTime,
                                                          "HH:mm:ss"
                                                        ).format("HH:mm")}
                                                      </Text>
                                                    </Button>
                                                  );
                                                }
                                              )}
                                            </Stack>
                                          ) : (

                                            <Button
                                              variant="default"
                                              radius="100px"
                                              onClick={() => {
                                                setSelectedTeam(team);
                                                setSelectedEditDate(currentDay);
                                                openMenu();
                                              }}
                                            >
                                              <Text size="xs" c="dark">
                                                کار نمیکنم
                                              </Text>
                                            </Button>
                                          )}
                                        </Group>
                                        <Divider />
                                      </>
                                    );
                                  })}
                                </Stack>
                              </>
                            );
                          })()}
                        </>
                      ) : (
                        <Stack align="center" justify="center" gap="xs">
                          <IconCalendarOff
                            color="var(--mantine-color-gray-5)"
                            stroke={1}
                          />
                          <Text c="gray.5" size="xs">
                            شیفت کاری تعریف نشده است
                          </Text>
                          <Button
                            variant="default"
                            radius="xl"
                            size="xs"
                            color="gray.8"
                            onClick={() => {
                              setSelectedTeam(team);
                              open();
                            }}
                          >
                            تعریف شیفت کاری
                          </Button>
                        </Stack>
                      )}
                    </Accordion.Panel>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Stack>
          )}
        </Stack>
      </Container>

      <Drawer
        opened={openedMenu}
        onClose={closeMenu}
        position="bottom"
        radius="md"
        size="xs"
      >
        <AddShiftMenu
          selectedTeam={selectedTeam || {}}
          selectedDate={selectedEditDate || moment()}
          openRepeatableShifts={open}
          openOneDayShift={openOneDayShift}
          closeMenu={closeMenu}
        />
      </Drawer>

      {/* <CustomDrawer
        opened={openedOneDayShift}
        onClose={closeOneDayShift}
        close={closeOneDayShift}
        position="bottom"
        radius="md"
        custom="one-day-shift-schedule"
        size="lg"
      >
        <Stack>{selectedEditDate?.format("dddd, jDD jMMMM")}</Stack>
      </CustomDrawer> */}
      {/* {openedOneDayShift && ( */}

      <AddTimeSlotForOneDay
        opened={openedOneDayShift}
        close={closeOneDayShift}
        refetchShiftSchedule={refetchShiftSchedule}
        selectedWeekDay={5 as number}
        selectedEditDate={selectedEditDate || moment()}
        selectedTeam={selectedTeam || {}}
        existingTimeSlots={
          selectedTeam?.workScheduleCalendar?.find((day) => {
            return (
              day?.availableDate === selectedEditDate?.format("YYYY-MM-DD")
            );
          })?.timeSlots
        }
      />

      <AddShift
        opened={opened}
        close={close}
        selectedTeam={selectedTeam || {}}
        selectedDate={selectedDate || []}
        shiftSchedule={shiftSchedule || []}
        setSelectedDate={setSelectedDate}
        refetchShiftSchedule={refetchShiftSchedule}
      />
    </>
  );
}

export default ShiftsSchedule;
